import { EMPTY_STRING } from '../../../constants/common'
import { HTML_LINK_TARGET } from '../../../constants/html'
import {
  useInitData,
  useIsProviderProfileNGAvailable,
  useIsUserProfileNGAvailable,
  useScreen,
  useUserData,
} from '../../../hooks'
import {
  isAdminUser,
  isStaffUser,
  isUnconfirmed as isUnconfirmedUser,
} from '../../../utils/user'
import { Search } from '../../Search'

import {
  getSearchConfigs,
  getSearchPagePath,
  getSearchRequestsType,
  getStaffSearchConfigs,
  getUnconfirmedSearchConfigs,
} from './LayoutSearch.utils'

function LayoutSearch({ isOpenSearch, ...restProps }) {
  const user = useUserData()
  const isStaff = isStaffUser(user)
  const isUnconfirmed = isUnconfirmedUser(user)
  const { availableSections } = useInitData()
  const isProviderProfileNGAvailable = useIsProviderProfileNGAvailable()
  const isUserProfileNGAvailable = useIsUserProfileNGAvailable()

  const { isMobileScreenSize } = useScreen()

  const requestsType = getSearchRequestsType({
    availableSections,
    withArchivedSearch: isStaff,
  })

  const configs = isStaff
    ? getStaffSearchConfigs({
        availableSections,
        isProviderProfileNGAvailable,
        isUserProfileNGAvailable,
        requestsType,
        withArchivedBuildingsSearch: isAdminUser(user),
        withArchivedContractorsSearch: isStaff,
        withArchivedEmailsSearch: isStaff,
        withArchivedFlatsSearch: isStaff,
        withArchivedUsersSearch: isAdminUser(user),
      })
    : isUnconfirmed
      ? getUnconfirmedSearchConfigs({ availableSections, requestsType })
      : getSearchConfigs({ availableSections, requestsType })

  const defaultSearch = {
    archived: false,
    text: EMPTY_STRING,
    type: requestsType,
  }

  function handleSearch(search) {
    const path = getSearchPagePath(search, availableSections)

    if (path) {
      window.open(path, HTML_LINK_TARGET.blank)
    }
  }

  function handleSelect(value) {
    window.open(value.search.type.links.item(value.item))
  }

  return !isMobileScreenSize || isOpenSearch ? (
    <Search
      {...restProps}
      configs={configs}
      defaultSearch={defaultSearch}
      onSearch={handleSearch}
      onSelect={handleSelect}
    />
  ) : null
}

export default LayoutSearch
